import { Transform, Type } from 'class-transformer';
import {
  IsArray,
  IsBoolean,
  IsDateString,
  IsEnum,
  IsNumber,
  IsOptional,
  IsPositive,
  IsString,
  ValidateNested,
} from 'class-validator';
import { OptionalStringTransform } from '../../validation/optional-string.transformer';
import { LotAllergenDto } from './lot-allergen.dto';

export class UpdateLotDto {
  @IsString()
  @IsOptional()
  name?: string;

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  description?: string;

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  notes?: string;

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  recipeName?: string;

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  supplierLot?: string;

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  supplierName?: string;

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  measurementUnit?: string;

  /** Quantità del lotto. `null` la svuota. Richiede un'unità di misura (nuova o già presente sul lotto). */
  @IsOptional()
  @IsNumber({ maxDecimalPlaces: 2 }, { message: 'error.lot.invalidQuantity' })
  @IsPositive({ message: 'error.lot.invalidQuantity' })
  quantity?: number | null;

  @IsDateString()
  @IsOptional()
  @Transform(({ value }) => {
    if (value instanceof Date) {
      return value.toISOString().split('T')[0];
    }
    return value;
  })
  productionDate?: string;

  @IsDateString()
  @IsOptional()
  @Transform(({ value }) => {
    if (value instanceof Date) {
      return value.toISOString().split('T')[0];
    }
    return value;
  })
  expiryDate?: string;

  /** Mutually exclusive with expiryDate. Server re-enforces XOR. */
  @IsBoolean()
  @IsOptional()
  hasNoExpiry?: boolean;

  @IsEnum(['ACTIVE', 'EXHAUSTED', 'EXPIRED'])
  @IsOptional()
  status?: 'ACTIVE' | 'EXHAUSTED' | 'EXPIRED';

  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => LotAllergenDto)
  allergens?: LotAllergenDto[];
}
